import api from './baseApi'

export function getAll() {
    return api.get(`Payments`)
}

export function getAllByUser(userId) {
    return api.get(`Payments/users/${userId}`)
}